import React from 'react';
import {FormattedMessage} from 'react-intl';

// Tutorial thumbnails: Avoid using any text that would need to be
// translated in thumbnails.
// Intro
import NanoMega328 from './thumbnails/ardunionano.jpg';
import Uno from './thumbnails/arduniouno.jpg';
import Leonardo from './thumbnails/ardunioleonardo.jpg';

export default {

    'NanoMega328': {
        name: (
            "Arduino Nano"
        ),
        img: NanoMega328
    },
    'Uno': {
        name: (
            "Arduino Uno"
        ),
        img: Uno
    },
    'Leonardo': {
        name: (
            "Arduino Leonardo"
        ),
        img: Leonardo
    }
};
